import React from 'react';
import { BookOpen, Brain, Target } from './Icons';

const ModeSelector = ({ currentMode, onModeChange, language = 'traditional' }) => {
  const modes = [
    {
      id: 'read',
      icon: BookOpen,
      name: {
        traditional: '閱讀模式',
        simplified: '阅读模式',
        english: 'Read Mode'
      },
      description: {
        traditional: '學習新詞彙和語法',
        simplified: '学习新词汇和语法',
        english: 'Learn new vocabulary and grammar'
      },
      color: 'from-blue-500 to-cyan-500'
    },
    {
      id: 'study',
      icon: Brain,
      name: {
        traditional: '學習模式',
        simplified: '学习模式',
        english: 'Study Mode'
      },
      description: {
        traditional: '互動練習和記憶',
        simplified: '互动练习和记忆',
        english: 'Interactive practice and memorization'
      },
      color: 'from-green-500 to-blue-500'
    },
    {
      id: 'test',
      icon: Target,
      name: {
        traditional: '測試模式',
        simplified: '测试模式',
        english: 'Test Mode'
      },
      description: {
        traditional: '檢驗學習成果',
        simplified: '检验学习成果',
        english: 'Test your knowledge'
      },
      color: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <div className="px-6 mb-6">
      <h2 className="text-lg font-semibold mb-4 text-white">
        {language === 'traditional' ? '選擇學習模式' : 
         language === 'simplified' ? '选择学习模式' : 
         'Choose Learning Mode'}
      </h2>
      <div className="grid grid-cols-1 gap-3">
        {modes.map((mode) => {
          const IconComponent = mode.icon;
          const isActive = currentMode === mode.id;
          
          return (
            <button
              key={mode.id}
              onClick={() => onModeChange(mode.id)}
              className={`p-4 rounded-xl border-2 transition-all ${
                isActive 
                  ? `border-cyan-400 bg-gradient-to-r ${mode.color}/20`
                  : 'border-gray-600 bg-gray-800/30'
              }`}
            >
              <div className="flex items-center space-x-4">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-r ${mode.color}`}>
                  <IconComponent className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1 text-left">
                  <h3 className="font-semibold text-white">{mode.name[language]}</h3>
                  <p className="text-gray-300 text-sm">{mode.description[language]}</p>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ModeSelector;
